import React, { useEffect, useState } from "react";
import { FaEye, FaPlus, FaSearch, FaTrashAlt } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import ConfirmDeleteModal from "../../Components/ConfirmDeleteModal/ConfirmDeleteModal";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import Input from "../../Components/Input/Input";
import AuthButton from "../../Components/AuthButton/AuthButton";
import { AiOutlineClose } from "react-icons/ai";
import {
  addEmpolyee,
  createTask,
  deleteEmployee,
  getEmployeebyid,
  getEmployees,
  getRoleDropDown,
  SINGLEEMPLOYEE,
  updateEmployee,
  UploadImage,
} from "../../Actions/actions";
import { useSelector } from "react-redux";
import Loader from "../../Components/Loader/Loader";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import DropDownCustom from "../../Components/DropDownCustom/DropDownCustom";
import { FaCalendarAlt, FaClock, FaCloudUploadAlt } from "react-icons/fa";
import { FaRegFileLines } from "react-icons/fa6";
import { IoMdCloudDownload } from "react-icons/io";
import ActiveModal from "../../Components/ActiveModal/ActiveModal";
import { subscriptionsCondition } from "../../Reducers/reducers";
import CustomToast from "../../Components/CustomToast/CustomToast";

const UserManagement = () => {
  const navigate = useNavigate();
  const { loginData, employeesData, loader, roledropdown, taskData, Privilages } = useSelector(
    (state) => state.userReducer
  );
  console.log(employeesData, "employeesData");
  const dispatch = useDispatch();
  const getEmployeesdata = () => {
    dispatch(getEmployees(loginData?.accessToken));
  };
  useEffect(() => {
    getEmployeesdata();
    dispatch(getRoleDropDown(loginData?.accessToken));
  }, []);

  const [deleteid, setdeleteid] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("Status");
  const [selectedRole, setSelectedRole] = useState("Role");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isActiveOpen, setIsActiveOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAssignmentModalOpen, setIsAssignmentModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [isEdit, setisEdit] = useState(false);
  const filteredUsers = employeesData.filter((user) => {
    const matchesSearch =
      user.FullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesRole = selectedRole == "" || selectedRole === "Role" || user.roleId === selectedRole;
    const matchesStatus = selectedStatus === "Status" || user.status === selectedStatus;

    return matchesSearch && matchesRole && matchesStatus;
  });
  const handleDelete = (id) => {
    setdeleteid(id);
    setIsDeleteModalOpen(true);
  };
  const handleActive = (id) => {
    setdeleteid(id);
    setIsActiveOpen(true);
  };
  const handleEdit = (id) => {
    dispatch(getEmployeebyid(loginData?.accessToken, id));
  };
  const handleChanges = (selectedOption, setterFunction) => {
    setterFunction(selectedOption.value);
  };
  // const statusOptions = [{
  //   value: 'Active', label: 'Active',
  //   value: 'InActive', label: 'InActive'
  // }]
  const roleOptions = [
    { value: "", label: "All" },
    ...roledropdown?.map((option) => ({
      value: option.id,
      label: option.roleName,
    })),
  ];

  const getStatusStyle = (status) => {
    console.log(status, "pp");
    if (status.includes("Active")) return "bg-green-600 text-white";
    if (status.includes("Inactive")) return "bg-yellow-600 text-white";
    return "bg-gray-100 text-gray-700";
  };
  const PrivilagesArray = Privilages?.length > 0 ? Privilages.filter((item) => item.feature === "User Management") : [];
  return (
    <ParentComponent>
      <PrimaryHeader
        PrivilagesCondition={
          PrivilagesArray?.length > 0 ? (PrivilagesArray[0].accessLevel == "Full Access" ? true : false) : true
        }
        buttonTextfirst="Urgent Assignment"
        onButtonClickfirst={true}
        buttonIconfirst={<FaRegFileLines className="mr-2" />}
        buttonText="Add New User"
        buttonIcon={<FaPlus className="mr-2" />}
        onButtonClick={() => {
          subscriptionsCondition(
            loginData?.clientData?.subscriptionType,
            () => {
              if (employeesData?.length >= 3) {
                toast.success(
                  <CustomToast
                    type={"Warn"}
                    message={"Only 3 employees allowed.Change Plan for creating more employees."}
                  />,
                  {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    icon: false,
                    closeButton: false,
                  }
                );
              } else {
                dispatch({
                  type: SINGLEEMPLOYEE,
                  payload: {},
                });
                setisEdit(false);
                setIsModalOpen(true);
              }
            },
            () => {
              if (employeesData?.length >= 20) {
                toast.success(
                  <CustomToast
                    type={"Warn"}
                    message={"Only 20 employees allowed.Change Plan for creating more employees."}
                  />,
                  {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    icon: false,
                    closeButton: false,
                  }
                );
              } else {
                dispatch({
                  type: SINGLEEMPLOYEE,
                  payload: {},
                });
                setisEdit(false);
                setIsModalOpen(true);
              }
            },
            () => {
              dispatch({
                type: SINGLEEMPLOYEE,
                payload: {},
              });
              setisEdit(false);
              setIsModalOpen(true);
            }
          );
        }}
        onfirstButtonClick={() => {
          subscriptionsCondition(
            loginData?.clientData?.subscriptionType,
            () => {
              if (taskData?.length >= 10) {
                toast.success(
                  <CustomToast type={"Warn"} message={"Only 10 task allowed.Change Plan for creating more tasks."} />,
                  {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    icon: false,
                    closeButton: false,
                  }
                );
              } else {
                setIsAssignmentModalOpen(true);
              }
            },
            () => {
              if (taskData?.length >= 100) {
                toast.success(
                  <CustomToast type={"Warn"} message={"Only 100 task allowed.Change Plan for creating more tasks."} />,
                  {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    icon: false,
                    closeButton: false,
                  }
                );
              } else {
                setIsAssignmentModalOpen(true);
              }
            },
            () => {
              setIsAssignmentModalOpen(true);
            }
          );
        }}
      />

      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="bg-white rounded-t-lg mb-4 flex md:flex-row sm:flex-col space-y-4 sm:space-y-0 sm:space-x-0 md:space-x-6 items-center self-center">
            <div className="relative md:w-4/6 sm:w-full mb-[15px] md:mb-0">
              <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#361D32]"
              />
            </div>

            <div className="md:mt-0 md:w-2/6 sm:w-full flex sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
              {/* <DropDownCustom
                isAligned={true}
                selectedValue={statusOptions.find(
                  (option) => option.value === selectedStatus
                )}
                handleChanges={(option) =>
                  handleChanges(option, setSelectedStatus)
                }
                options={statusOptions}
                isSearchable={false}
                label="Status"
                placeholder="Select Status"
              /> */}

              <DropDownCustom
                isAligned={true}
                selectedValue={roleOptions?.find((option) => option.value === selectedRole)}
                handleChanges={(option) => handleChanges(option, setSelectedRole)}
                options={roleOptions}
                isSearchable={false}
                label="Role"
                placeholder="Select Role"
              />
            </div>
          </div>

          <div className="overflow-x-auto bg-white shadow-md rounded-lg overflow-hidden">
            <div className="bg-white  rounded-lg">
              <table className="min-w-full">
                <thead className="bg-[#361D3214]">
                  <tr className="text-gray-500 text-sm">
                    <th className="px-4 py-4 text-left text-sm font-semibold text-gray-600 min-w-[200px]">User Name</th>
                    <th className="py-4 text-left text-sm font-semibold text-gray-600 min-w-[150px]">Email</th>
                    <th className="py-4 text-center text-sm font-semibold text-gray-600 min-w-[120px]">Role</th>
                    <th className="py-4 text-center text-sm font-semibold text-gray-600 min-w-[120px]">Status</th>
                    {/* <th className="py-3 text-left text-sm font-semibold text-gray-600 min-w-[120px]">
                      Last Login
                    </th> */}
                    <th className="py-4 text-center text-sm font-semibold text-gray-600">Action</th>
                  </tr>
                </thead>
                <tbody className="text-sm text-gray-800">
                  {filteredUsers?.length > 0 ? (
                    filteredUsers.map((user) => (
                      <tr key={user.id} className="border-t border-gray-200">
                        <td className="px-6 py-4 flex items-center space-x-4 min-w-[275px]">
                          <span className="flex w-8 h-8 bg-gray-200 rounded-full items-center justify-center">
                            {user?.logo ? (
                              <img src={user?.logo} className="w-8 h-8 rounded-full" alt="User Avatar" />
                            ) : (
                              <p className="font-normal text-gray-400 text-lg">{user.FullName?.slice(0, 1)}</p>
                            )}
                          </span>

                          <div>
                            <p className="text-sm font-medium text-gray-800">{user.FullName}</p>
                            <p className="text-xs text-gray-500">
                              {user?.countryCode}
                              {user?.phoneNumber}
                            </p>
                          </div>
                        </td>
                        <td className="py-4 text-sm text-gray-600">{user.email}</td>
                        <td className="px-4 text-center py-4 text-sm text-gray-600">{user.roleName}</td>
                        <td onClick={() => handleActive(user.id)} className="px-4 py-4 text-center text-sm">
                          <span
                            className={`px-3 py-1 rounded  ${getStatusStyle(
                              user?.isActive == 1 ? "Active" : "Inactive"
                            )}`}
                          >
                            {user?.isActive == 1 ? "Active" : "Inactive"}
                          </span>
                        </td>

                        <td className=" justify-center py-3 flex space-x-2">
                          <button
                            className="text-gray-600 hover:text-blue-500 bg-gray-100 p-2 rounded-full"
                            onClick={() => {
                              handleEdit(user.id);
                              navigate("/user-management/user-details");
                            }}
                          >
                            <FaEye />
                          </button>
                          {PrivilagesArray?.length > 0 ? (
                            PrivilagesArray[0].accessLevel !== "View Only" ? (
                              <button
                                className="text-gray-600 hover:text-yellow-500 bg-gray-100 p-2 rounded-full"
                                onClick={() => {
                                  handleEdit(user.id);
                                  setisEdit(true);
                                  setIsModalOpen(true);
                                }}
                              >
                                <MdEdit />
                              </button>
                            ) : null
                          ) : (
                            <button
                              className="text-gray-600 hover:text-yellow-500 bg-gray-100 p-2 rounded-full"
                              onClick={() => {
                                handleEdit(user.id);
                                setisEdit(true);
                                setIsModalOpen(true);
                              }}
                            >
                              <MdEdit />
                            </button>
                          )}

                          {PrivilagesArray?.length > 0 ? (
                            PrivilagesArray[0].accessLevel == "Full Access" ? (
                              <button
                                className="text-gray-600 hover:text-red-500 bg-gray-100 p-2 rounded-full"
                                onClick={() => handleDelete(user.id)}
                              >
                                <FaTrashAlt />
                              </button>
                            ) : null
                          ) : (
                            <button
                              className="text-gray-600 hover:text-red-500 bg-gray-100 p-2 rounded-full"
                              onClick={() => handleDelete(user.id)}
                            >
                              <FaTrashAlt />
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center py-6 text-gray-500">
                        No users found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <ActiveModal
            isOpen={isActiveOpen}
            onClose={() => {
              setIsActiveOpen(false);
            }}
            onConfirm={() => {
              dispatch(
                deleteEmployee(loginData?.accessToken, deleteid, () => {
                  getEmployeesdata();
                  setIsActiveOpen(false);
                })
              );
            }}
          />
          <ConfirmDeleteModal
            isOpen={isDeleteModalOpen}
            onClose={() => {
              setIsDeleteModalOpen(false);
            }}
            onConfirm={() => {
              dispatch(
                deleteEmployee(loginData?.accessToken, deleteid, () => {
                  getEmployeesdata();
                  setIsDeleteModalOpen(false);
                })
              );
            }}
          />
          <CreateUserForm
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onHit={getEmployeesdata}
            edit={isEdit}
          />
          <UrgentAssignmentModal
            isOpen={isAssignmentModalOpen}
            onClose={() => setIsAssignmentModalOpen(false)}
            data={employeesData}
          />
        </>
      )}
    </ParentComponent>
  );
};

export default UserManagement;

const CreateUserForm = ({ isOpen, onClose, onHit, edit }) => {
  const { loginData, loader, subLoader, singleEmployee, roledropdown } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    FullName: "",
    phoneNumber: "",
    Email: "",
    Roles: "",
    RoleId: 0,
    roleId: 0,
    Password: "",
    countryCode: "+971",
    // IsVehicle: false,
    // IsMobile: false,
    // IsLaptop: false,
    // IsFuel: false,
    // VehicleType: "",
    // VehicleNumber: "",
    UploadLicense: "",
    EmirateId: "",
    // MobileModel: "",
    // LaptopModel: "",
    // LaptopEmirateId: "",
    // FuelType: "",
    // MobileEmirateId: "",
    // VehicleEmirateId: "",
    monthlyTarget: 0,
    quarterlyTarget: 0,
    yearlyTarget: 0,
    FuelLimit: 0,
  });
  console.log(formData, "formDatahammad");

  useEffect(() => {
    setFormData({
      FullName: singleEmployee.FullName ? singleEmployee.FullName : "",
      FuelLimit: singleEmployee.fuelLimit ? singleEmployee.fuelLimit : 0,
      phoneNumber: singleEmployee.phoneNumber ? singleEmployee.phoneNumber : "",
      Email: singleEmployee.email ? singleEmployee.email : "",
      Roles: singleEmployee.roleName ? singleEmployee.roleName : "",
      roleName: singleEmployee.roleName ? singleEmployee.roleName : "",
      Password: singleEmployee.Password ? singleEmployee.Password : "",
      // IsVehicle: singleEmployee.IsVehicle ? singleEmployee.IsVehicle : false,
      // IsMobile: singleEmployee.IsMobile ? singleEmployee.IsMobile : false,
      // IsLaptop: singleEmployee.IsLaptop ? singleEmployee.IsLaptop : false,
      // IsFuel: singleEmployee.IsFuel ? singleEmployee.IsFuel : false,
      // VehicleType: singleEmployee.VehicleType ? singleEmployee.VehicleType : "",
      // VehicleNumber: singleEmployee.VehicleNumber ? singleEmployee.VehicleNumber : "",
      // VehicleEmirateId: singleEmployee.VehicleEmirateId ? singleEmployee.VehicleEmirateId : "",
      UploadLicense: singleEmployee.UploadLicense ? singleEmployee.UploadLicense : "",
      EmirateId: singleEmployee.EmirateId ? singleEmployee.EmirateId : "",
      // MobileModel: singleEmployee.MobileModel ? singleEmployee.MobileModel : "",
      // MobileEmirateId: singleEmployee.MobileEmirateId ? singleEmployee.MobileEmirateId : "",
      // LaptopModel: singleEmployee.LaptopModel ? singleEmployee.LaptopModel : "",
      // LaptopEmirateId: singleEmployee.LaptopEmirateId ? singleEmployee.LaptopEmirateId : "",
      // FuelType: singleEmployee.FuelType ? singleEmployee.FuelType : "",
      roleId: singleEmployee.roleId ? singleEmployee.roleId : 0,
      monthlyTarget: singleEmployee.monthlyTarget ? singleEmployee.monthlyTarget : 0,
      quarterlyTarget: singleEmployee.quarterlyTarget ? singleEmployee.quarterlyTarget : 0,
      yearlyTarget: singleEmployee.yearlyTarget ? singleEmployee.yearlyTarget : 0,
      countryCode: singleEmployee?.countryCode ? singleEmployee?.countryCode : "+971",
    });
  }, [singleEmployee]);
  const handleNestedChange = (field, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  if (!isOpen) return null;
  const handleFileChange = (e) => {
    dispatch(
      UploadImage(e.target.files[0], "", (data) => {
        setFormData({ ...formData, UploadLicense: data.data.fileUrl });
      })
    );
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setErrors((prevState) => ({
        ...prevState,
        [name]: "",
      }));
    }
  };

  const options = roledropdown?.map((option) => ({
    value: option.id,
    label: option.roleName,
  }));
  const VehicleOption = [
    { value: "Car", label: "Car" },
    { value: "Bike", label: "Bike" },
    { value: "HTV /LTV", label: "HTV /LTV" },
  ];
  const FuelOption = [
    { value: "CNG", label: "CNG" },
    { value: "Petrol", label: "Petrol" },
    { value: "Diesel", label: "Diesel" },
  ];
  const handleChanges = (selectedOption) => {
    setErrors((prev) => ({ ...prev, Roles: "" }));
    const roleName = selectedOption.label;
    const roleId = selectedOption.value;
    handleNestedChange("Roles", roleName);
    handleNestedChange("roleName", roleName);
    handleNestedChange("roleId", roleId);
    handleNestedChange("RoleId", roleId);
  };
  const selectedValue = options?.find((option) => option.value === formData?.roleId);

  const validateForm = () => {
    let newErrors = {};

    if (!formData.FullName) {
      newErrors.FullName = "Full Name is required";
    }
    if (!formData.Email) {
      newErrors.Email = "Email is required";
    }
    if (!formData.phoneNumber) {
      newErrors.phoneNumber = "Phone Number is required";
    }
    // Fixed Role validation
    if (!formData.roleId || formData.roleId === 0) {
      newErrors.Roles = "Role is required";
    }
    if (!formData.Password && !edit) {
      newErrors.Password = "Password is required";
    }
    if (!formData.monthlyTarget && formData.Roles === "Sales Executive") {
      newErrors.monthlyTarget = "Monthly Target is required";
    }
    if (!formData.yearlyTarget && formData.Roles === "Sales Executive") {
      newErrors.yearlyTarget = "Yearly Target is required";
    }
    if (!formData.quarterlyTarget && formData.Roles === "Sales Executive") {
      newErrors.quarterlyTarget = "Quarterly Target is required";
    }
    setErrors(newErrors);
    console.log(newErrors, "p");
    return Object.keys(newErrors)?.length === 0;
  };
  const handleSubmit = (e) => {
    if (validateForm()) {
      if (edit) {
        dispatch(
          updateEmployee(singleEmployee?.id, formData, loginData?.accessToken, () => {
            toast.success(<CustomToast type={"Success"} message={"Employee updated successfully"} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });

            onHit();
            onClose();
          })
        );
      } else {
        if (roledropdown?.length === 1) {
          setFormData({
            ...formData,
            Roles: roledropdown[0]?.roleName,
            RoleId: roledropdown[0]?.id,
          });
        }
        console.log(formData, "formdata");
        dispatch(
          addEmpolyee(formData, loginData?.accessToken, () => {
            onHit();
            onClose();
          })
        );
      }
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-4 w-full">
      <div onClick={onClose} className="bg-gray-800 opacity-50 fixed inset-0"></div>

      <div className="bg-white rounded-lg shadow-lg px-4 pt-4 w-[95%] md:w-[60%] relative">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold">Create New User</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <AiOutlineClose />
          </button>
        </div>
        <div className="h-[70vh] overflow-y-auto">
          <form className="space-y-4 mt-2">
            <Input
              type="text"
              placeholder="Full name"
              name="FullName"
              value={formData.FullName}
              onChange={handleChange}
              float
              label="Full Name*"
              error={errors.FullName}
            />
            <div>
              <div className="grid grid-cols-2 gap-4 mt-6">
                <Input
                  type="email"
                  placeholder="Email"
                  name="Email"
                  value={formData.Email}
                  onChange={handleChange}
                  float
                  label="Email*"
                  error={errors.Email}
                  // disabled={edit ? true : false}
                />
                <Input
                  label="Phone Number*"
                  isPhoneNumber
                  countryCodeValue={formData?.countryCode}
                  onCountryChange={(newCountryCode) => {
                    setFormData((prev) => ({
                      ...prev,
                      countryCode: newCountryCode,
                    }));
                  }}
                  type="text"
                  placeholder="Phone Number"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      phoneNumber: e.target.value,
                    }));

                    setErrors((prev) => ({ ...prev, phoneNumber: "" }));
                  }}
                  float
                  error={errors.phoneNumber}
                />
              </div>

              <div className="grid grid-cols-2 gap-4 mt-1">
                <div>
                  <DropDownCustom
                    selectedValue={selectedValue}
                    handleChanges={handleChanges}
                    options={options}
                    isSearchable={false}
                    label="Role*"
                    placeholder={"Select Role"}
                  />
                  {errors.Roles && <p className="text-red-500 text-sm">{errors.Roles}</p>}
                </div>
                {edit ? null : (
                  <Input
                    type="password"
                    placeholder="Password"
                    name="Password"
                    value={formData.Password}
                    onChange={handleChange}
                    password={true}
                    className={"mt-[24px] mb-0"}
                    label={"Password*"}
                    error={errors.Password}
                  />
                )}
              </div>
              {formData?.Roles === "Sales Executive" && (
                <>
                  <div className="grid grid-cols-2 gap-4 mb-6" style={{ marginTop: edit === true ? 25 : 0 }}>
                    <Input
                      type="text"
                      placeholder="Monthly Target"
                      label="Monthly Target*"
                      name="monthlyTarget"
                      value={formData.monthlyTarget}
                      onChange={handleChange}
                      float
                      error={errors.monthlyTarget}
                      left={"AED"}
                    />
                    <Input
                      type="text"
                      placeholder="Quarterly Target"
                      label="Quarterly Target*"
                      name="quarterlyTarget"
                      value={formData.quarterlyTarget}
                      onChange={handleChange}
                      float
                      error={errors.quarterlyTarget}
                      left={"AED"}
                    />
                  </div>
                  <Input
                    type="text"
                    placeholder="Yearly Target"
                    label="Yearly Target*"
                    name="yearlyTarget"
                    value={formData.yearlyTarget}
                    onChange={handleChange}
                    float
                    error={errors.yearlyTarget}
                    left={"AED"}
                  />
                </>
              )}
            </div>
            {/* <div className="grid grid-cols-2 gap-6 ml-2">
              {["IsVehicle", "IsMobile", "IsLaptop", "IsFuel"].map((option) => (
                <label key={option} className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    name={option}
                    checked={formData[option]}
                    onChange={handleChange}
                    className="accent-purple-600"
                  />
                  <span className="capitalize">{option.replace("Is", "")}</span>
                </label>
              ))}
            </div> */}

            <div className=" rounded-lg ">
              <h3 className="font-semibold mb-6 ">Driving Licence</h3>
              {/* <div className="grid grid-cols-2 gap-4">
                  <div className="-mt-5">
                    <DropDownCustom
                      selectedValue={VehicleOption?.find((option) => option.value === formData.VehicleType)}
                      handleChanges={(e) => handleNestedChange("VehicleType", e.value)}
                      options={VehicleOption}
                      isSearchable={false}
                      label="Vehicle Type"
                      placeholder={"Select Vehicle Type"}
                    />
                  </div>

                  <Input
                    type="text"
                    placeholder="Vehicle Number"
                    name="VehicleNumber"
                    float
                    value={formData.VehicleNumber}
                    onChange={handleChange}
                  />
                </div> */}
              <div>
                <Input
                  type="file"
                  placeholder="Upload License"
                  label="Upload License"
                  value={formData.UploadLicense}
                  onChange={handleFileChange}
                  error={errors.UploadLicense}
                />
                {formData?.UploadLicense ? (
                  <div
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = formData?.UploadLicense;
                      link.setAttribute("download", "filename");
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                    className="ml-2 flex flex-row items-center gap-1  cursor-pointer"
                  >
                    <IoMdCloudDownload className=" text-gray-800 text-lg" />
                    <p className="text-gray-800 font-bold text-xs">Download</p>
                  </div>
                ) : null}
              </div>
              {/* <div className="grid grid-cols-2 gap-4 mt-6 ">
                  <Input
                    type="text"
                    label="Vehicle Id"
                    float={true}
                    onChange={handleChange}
                    value={formData.VehicleEmirateId}
                    name={"VehicleEmirateId"}
                  />
                </div> */}
            </div>
            {/* {formData.IsVehicle && (
            )} */}
            {/* {formData.IsMobile && (
              <div className=" rounded-lg">
                <h3 className="font-semibold my-6">Mobile</h3>
                <div className="grid grid-cols-2 gap-4">
                  <Input
                    type="text"
                    placeholder="Model"
                    name="Model"
                    float
                    value={formData.MobileModel}
                    onChange={(e) => handleNestedChange("MobileModel", e.target.value)}
                  />
                  <Input
                    type="text"
                    placeholder="Emirate ID"
                    label="Serial Number"
                    float
                    value={formData.MobileEmirateId}
                    onChange={(e) => handleNestedChange("MobileEmirateId", e.target.value)}
                  />
                </div>
              </div>
            )} */}
            {/* {formData.IsLaptop && (
              <div className="rounded-lg">
                <h3 className="font-semibold my-6">Laptop</h3>
                <div className="grid grid-cols-2 gap-4">
                  <Input
                    placeholder="Model"
                    name="Model"
                    float
                    value={formData.LaptopModel}
                    onChange={(e) => handleNestedChange("LaptopModel", e.target.value)}
                  />
                  <Input
                    type="text"
                    placeholder="Emirate ID"
                    label="Device Id"
                    float
                    value={formData.LaptopEmirateId}
                    onChange={(e) => handleNestedChange("LaptopEmirateId", e.target.value)}
                  />
                </div>
              </div>
            )} */}
            <div className="rounded-lg">
              <h3 className="font-semibold my-6">Fuel </h3>
              <div className="-mt-5">
                {/* <div className="relative top-3 left-4 bg-white px-1 w-[150px] mt-[-25px]">
                    <label className="text-sm font-medium text-gray-600">
                      Fuel Type
                    </label>
                  </div> */}
                <Input
                  type="text"
                  placeholder="Fuel Limit"
                  label="Fuel Limit"
                  float
                  value={formData.FuelLimit}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d*$/.test(val)) {
                      handleNestedChange("FuelLimit", val);
                    }
                  }}
                  right={"AED"}
                />
                {/* <DropDownCustom
                    selectedValue={FuelOption?.find(
                      (option) => option.value === formData.FuelType
                    )}
                    handleChanges={(e) =>
                      handleNestedChange("FuelType", e.value)
                    }
                    options={FuelOption}
                    isSearchable={false}
                    label="Fuel Type"
                    placeholder={"Select Fuel Type"}
                  /> */}
                {/* <select
                    value={formData.FuelType}
                    onChange={(e) =>
                      handleNestedChange("FuelType", e.target.value)
                    }
                    className="border border-gray-300 rounded-lg p-2 py-3.5 w-full"
                  >
                    <option value="Patrol">Patrol</option>
                    <option value="CNG">CNG</option>
                    <option value="Diesel">Diesel</option>
                  </select> */}
              </div>
            </div>
            {/* {formData.IsFuel && (
            )} */}
          </form>
        </div>
        <div className="flex justify-end space-x-4  ">
          {subLoader ? (
            <Loader />
          ) : (
            <div className="flex justify-end mt-4  space-x-4">
              <AuthButton
                onClick={onClose}
                className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
                width={"20%"}
                title={"Cancel"}
              />
              <AuthButton
                width={"20%"}
                title={edit ? "Edit" : "Create"}
                className="px-4 py-2 text-white rounded-md"
                onClick={handleSubmit}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const UrgentAssignmentModal = ({ isOpen, onClose, data }) => {
  const { loginData } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [filename, setfilename] = useState("");
  const [formData, setFormData] = useState({
    assignedToId: "",
    title: "",
    description: "",
    dueDate: "",
    dueTime: "",
    attachmentUrl: "",
    isUrgent: true,
    priority: "",
  });

  const [errors, setErrors] = useState({
    assignedToId: "",
    title: "",
    description: "",
    dueDate: "",
    dueTime: "",
    attachmentUrl: "",
    priority: "",
  });

  const validateForm = () => {
    let newErrors = {};

    if (!formData.assignedToId) {
      newErrors.assignedToId = "Sales Rep is required";
    }
    if (!formData.title) {
      newErrors.title = "Task is required";
    }
    if (!formData.description) {
      newErrors.description = "Details are required";
    }
    if (!formData.dueDate) {
      newErrors.dueDate = "Due Date is required";
    }
    if (!formData.dueTime) {
      newErrors.dueTime = "Time is required";
    }
    if (!formData.priority) {
      newErrors.priority = "Priority define is required";
    }
    // if (!formData.attachmentUrl) {
    //   newErrors.attachmentUrl = "Attachments is required";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };
  const options = data?.map((value) => {
    return { label: value.FullName, value: value.id };
  });
  const priorityOptions = [
    { label: "High", value: "High" },
    { label: "Medium", value: "Medium" },
    { label: "Low", value: "Low" },
  ];
  const selectedValue = options?.find((option) => option.value === formData.assignedToId);
  const selectedValuePriority = priorityOptions?.find((option) => option.value === formData.priority);
  if (!isOpen) return null;

  const handleFileChange = (e) => {
    setErrors({ ...errors, attachmentUrl: "" });
    const file = e.target.files[0];
    setfilename(file.name);
    if (file) {
      dispatch(
        UploadImage(file, "", (data) => {
          setFormData({ ...formData, attachmentUrl: data.data.fileUrl });
        })
      );
    }
  };

  const triggerFileUpload = () => {
    document.getElementById("fileUploadInput").click();
  };

  const handleChanges = (selectedOption) => {
    setErrors((prevData) => ({ ...prevData, assignedToId: "" }));
    setFormData((prevData) => ({
      ...prevData,
      assignedToId: selectedOption.value,
    }));
  };
  const handleChangesPriority = (selectedOption) => {
    setErrors((prevData) => ({ ...prevData, priority: "" }));

    setFormData((prevData) => ({
      ...prevData,
      priority: selectedOption.value,
    }));
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleCreate = () => {
    console.log("formData", formData);
    if (validateForm()) {
      setLoading(true);
      dispatch(
        createTask(formData, loginData?.accessToken, () => {
          setLoading(false);
          onClose();
          setfilename("");
          setFormData({
            assignedToId: "",
            title: "",
            description: "",
            dueDate: "",
            dueTime: "",
            attachmentUrl: "",
            isUrgent: true,
          });
        })
      );
    }
  };

  console.log(formData);
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-4 w-full">
      <div onClick={onClose} className="bg-gray-800 opacity-50 fixed inset-0"></div>
      <div className="bg-white rounded-lg shadow-lg px-4 pt-4 w-[95%] max-h-[90%] overflow-scroll  md:w-[60%] relative">
        <div className="flex justify-between items-center ">
          <h2 className="text-xl font-bold">Urgent Assignment</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <AiOutlineClose />
          </button>
        </div>
        <DropDownCustom
          selectedValue={selectedValue}
          handleChanges={handleChanges}
          options={options}
          isSearchable={false}
          label="Sales Rep Selection*"
          placeholder="Select Sales Rep"
        />
        {errors.assignedToId !== "" && <p className="text-red-500 text-sm mt-1">{errors.assignedToId}</p>}
        <div className="mt-4">
          <Input
            type="text"
            label="Task*"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            placeholder="Task"
            float={true}
            error={errors.title}
          />
        </div>

        <div className="mt-4">
          <Input
            textarea={true}
            placeholder="Enter details"
            label="Details*"
            name="details"
            value={formData.description}
            onChange={(e) => {
              setFormData({ ...formData, description: e.target.value });
            }}
            error={errors.description}
          />
        </div>

        <div className="flex gap-4 mt-4">
          <div className="w-1/2">
            <div className="relative">
              <Input
                type="date"
                float={true}
                label="Due Date*"
                name="dueDate"
                value={formData.dueDate}
                onChange={handleInputChange}
                error={errors.dueDate}
              />
            </div>
          </div>
          <div className="w-1/2">
            <div className="relative">
              <Input
                type="time"
                float={true}
                label="Time*"
                name="dueTime"
                value={formData.dueTime}
                onChange={handleInputChange}
                error={errors.dueTime}
              />
              {/* <FaClock className="absolute top-5 right-3 text-gray-900" /> */}
            </div>
          </div>
        </div>
        <DropDownCustom
          selectedValue={selectedValuePriority}
          handleChanges={handleChangesPriority}
          options={priorityOptions}
          isSearchable={false}
          label="Priority*"
          placeholder="Select priority"
        />
        {errors.priority !== "" && <p className="text-red-500 text-sm mt-1">{errors.priority}</p>}
        <div
          className="mt-4 border border-dashed border-gray-300 p-6 rounded-lg text-center cursor-pointer"
          onClick={triggerFileUpload}
        >
          {formData.attachmentUrl ? (
            <div>
              <p className="text-gray-700 mb-2">Uploaded: {filename}</p>
              <button
                className="text-red-500 underline"
                onClick={() =>
                  setFormData((prevData) => ({
                    ...prevData,
                    attachmentUrl: null,
                  }))
                }
              >
                Remove File
              </button>
            </div>
          ) : (
            <div>
              <FaCloudUploadAlt className="text-gray-400 mx-auto mb-2" size={40} />
              <p className="text-gray-500">Click to upload file</p>
            </div>
          )}
          <input id="fileUploadInput" type="file" className="hidden" onChange={handleFileChange} />
          {errors.attachmentUrl !== "" && <p className="text-red-500 text-sm mt-1">{errors.attachmentUrl}</p>}
        </div>

        <div className="flex justify-end mt-6 space-x-4">
          <AuthButton
            onClick={onClose}
            className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
            width="20%"
            title="Cancel"
            disabled={loading}
          />
          <AuthButton
            width="20%"
            title="Create"
            className="px-4 py-2 text-white rounded-md"
            onClick={handleCreate}
            loading={loading}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );
};
